import request from '@/utils/request'
import { ChanceModifiesResult } from '@/typings/api/yuntuSales'

/**
 * ************************************** 分析 **************************************
 */
// 商机变动情况
export function chanceModifies(data: any) {
  return request.post<ChanceModifiesResult>('/lbu/api/saleChanceChange/page', data)
}

// 销售辅导情况
export function salesCoachingReport(data: any) {
  return request.post<ChanceModifiesResult>('/lbu/api/salesCoaching/report/list', data)
}
